/**
 * NotFound - 404 Route Wrapper
 *
 * Purpose: Wraps branded NotFoundPage component with router navigation
 * Shows on any unmatched route
 */

import { useNavigate } from 'react-router-dom';
import { NotFoundPage } from '@/components/brand';
import { BRAND_IMAGES } from '@/styles/tokens';
import { useAuth } from '@/contexts';

export default function NotFound() {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  const handleGoHome = () => {
    // Navigate to appropriate home based on auth state
    if (isAuthenticated) {
      navigate('/app/dashboard', { replace: true });
    } else {
      navigate('/', { replace: true });
    }
  };

  return <NotFoundPage onGoHome={handleGoHome} />;
}
